import templateUrl from "servicestack/tags/tags-fieldset.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import config from "servicestack/tags/_config";
import labels from "servicestack/tags/_labels";

class controller {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.config = config;
    $ctrl.labels = labels;
    $ctrl.singleConverter = {};
  }

  single(kind, value) {
    const $ctrl = this;
    if (value !== undefined) {
      $ctrl.tags[kind] = value ? [value] : [];
    }
    return ($ctrl.tags[kind] || [])[0];
  }

  $onInit() {
    const $ctrl = this;

    const criteria = {};

    criteria.tagKindIn = $ctrl.tagKinds;

    $ctrl.query = new AutoQuery({
      url: "QueryTagConfigs.json?Shard=" + $ctrl.shard,
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      orderBy: "Position,TagKind",
      criteria,
      scrub(response) {
        $ctrl.tagConfig = _.groupBy(response.data.results, "tagKind");
        if (Array.isArray($ctrl.tagKinds))
          response.data.results = _.sortBy(response.data.results, (m) =>
            $ctrl.tagKinds.indexOf(m.tagKind)
          );
        response.data.results.forEach((tc) => {
          $ctrl.singleConverter[tc.tagKind] = (value) =>
            $ctrl.single(tc.tagKind, value);
        });
      },
      autoLoad: true,
      pageSize: 100,
    });
  }
}

export default {
  bindings: {
    tagConfig: "=",
    tags: "<ngModel",
    tagKinds: "<",
    tagRequired: "<",
    shard: "@",
    colSplit: "@",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
